<template>
  <div>
    <SGPColComponent cols="6" v-if="dados.log_execucao && dados.log_execucao !== null && dados.log_execucao !== 'Sucesso'">
      <div>
        <SGPAlertaComponent>{{dados.log_execucao}}</SGPAlertaComponent>
      </div>
    </SGPColComponent>
    <div class="sga-plus-timeline pl-5 pr-5">
      <div class="box" v-for="(box, index) in timelineSgap" :key="index">
        <div v-if="box.title != '5'" :class="`box-line ${['completed'].includes(box.status) ? 'primary' : ''}`"></div>
        <div v-if="box.title == '5'" :class="`text-center`"></div>
        <div class="box-content ">
          <span></span>
          <div :class="`
            circulo
            ${['completed'].includes(box.status) ? 'circulo-completed' : ''}
            ${['incomplete'].includes(box.status) ? 'circulo-incomplete' : ''}
          `" style="color:white">{{ box.title }}
          </div>
          <span :class="`${['incomplete'].includes(box.status) ? 'desativado' : ''}`">{{ box.data || '---' }}</span>
          <span :class="`${['incomplete'].includes(box.status) ? 'desativado' : 'text-black'}`">{{ box.fase }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: "AprovisionarServicoComponent",

  props: {
    dados: {
      type: Object,
      required: true
    },
  },

  computed: {
    timelineSgap () {
      return [{
            title: '1',
            fase: 'Alocação de CF',
            data: this.dados && this.dados.alocacao_cf ? moment(this.dados.alocacao_cf).format('DD/MM/YYYY') : '',
            status: this.dados && this.dados.alocacao_cf ? 'completed' : 'incomplete'
          },
          {
            title: '2',
            fase: 'Tratar Acesso - Envio ao CLA',
            data: this.dados && this.dados.tratar_acesso ? moment(this.dados.tratar_acesso).format('DD/MM/YYYY') : '',
            status: this.dados && this.dados.tratar_acesso ? 'completed' : 'incomplete'
          },
          {
            title: '3',
            fase: 'Finalização Tratar Acesso',
            data: this.dados && this.dados.finalizacao_tratar_acesso ? moment(this.dados.finalizacao_tratar_acesso).format('DD/MM/YYYY') : '',
            status: this.dados && this.dados.finalizacao_tratar_acesso ? 'completed' : 'incomplete'
          },
          {
            title: '4',
            fase: 'Pré-Ativação',
            data: this.dados && this.dados.pre_ativacao ? moment(this.dados.pre_ativacao).format('DD/MM/YYYY') : '',
            status: this.dados && this.dados.pre_ativacao ? 'completed' : 'incomplete'
          },
          {
            title: '5',
            fase: 'Ativação / Finalização',
            data: this.dados && this.dados.ativacao_finalizacao ? moment(this.dados.ativacao_finalizacao).format('DD/MM/YYYY') : '',
            status: this.dados && this.dados.ativacao_finalizacao ? 'completed' : 'incomplete'
          }]
        }
  },

}
</script>

<style lang="scss" scoped>

.sga-plus-timeline {
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  height: 100px;
  margin-top: 30px;
  margin-left: 50px;

  div.box {
    width: 99%;
    align-items: center;
    justify-content: center;
    position: relative;
    
    .box-line{
      content: "";
      height: 2px;
      width: 100%;
      background: #ccc;
      position: absolute;
      top: 26%;
      z-index: 1;
      margin-top: -5px;
      left: 15px;
    }

    &:last-child {
      width: 160px;
    }

    .box-content {
      display: flex;
      flex-direction: column;      
      max-width: 180px;
      align-items: right;
      width: 200px;
      text-align: center;

      &:first-child {
        text-align: left;
      }

      .desativado {
        color: #ccc;
      }

      span {
        position: relative;
        max-width: 200px;
        display: block;
        left: -74px;
        font-weight: 500;
        color: #E3262E;
        font-size: 12px;
      }
    }

    div.circulo {
      position: inherit;
      width: 30px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      border: 3px solid #E3262E;
      background: #fff;
      z-index: 3;
    }

    div.circulo-completed {
      background: #E3262E;
    }

    div.circulo-incomplete {
      border-color: #ccc;
      background: #ccc;
    }
  }
}
</style>